webpackJsonp([219],{

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTaskPackageConfig_vue__ = __webpack_require__(2933);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02629a1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTaskPackageConfig_vue__ = __webpack_require__(5246);
function injectStyle (ssrContext) {
  __webpack_require__(5240)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02629a1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTaskPackageConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02629a1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTaskPackageConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return opts; });
/* unused harmony export getOptionLabel */
/* harmony export (immutable) */ __webpack_exports__["c"] = getDisplayStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDisplayFormLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDisplayStatusTagType;
/* harmony export (immutable) */ __webpack_exports__["e"] = isDisplayEnabled;
/* harmony export (immutable) */ __webpack_exports__["f"] = isDisplayPartial;
var consts = {
  /** 全部展示 */
  DISPLAY_ALL: 1,
  /** 部分展示 */
  DISPLAY_PARTIAL: 2,
  /** 不展示 */
  DISPLAY_NONE: 3
};

var opts = {
  /** 列表展示状态（短文案） */
  displayStatusMaps: [{ value: consts.DISPLAY_ALL, label: '全部展示' }, { value: consts.DISPLAY_PARTIAL, label: '部分展示' }, { value: consts.DISPLAY_NONE, label: '不展示' }],
  /** 表单单选（完整文案） */
  displayFormMaps: [{ value: consts.DISPLAY_ALL, label: '展示，所有用户可见' }, { value: consts.DISPLAY_PARTIAL, label: '展示，部分用户可见' }, { value: consts.DISPLAY_NONE, label: '不展示任务包' }]
};

function getOptionLabel(options, value) {
  var item = (options || []).find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getDisplayStatusLabel(display) {
  return getOptionLabel(opts.displayStatusMaps, display) || '不展示';
}

function getDisplayFormLabel(display) {
  return getOptionLabel(opts.displayFormMaps, display) || '不展示任务包';
}

function getDisplayStatusTagType(display) {
  switch (Number(display)) {
    case consts.DISPLAY_ALL:
      return 'success';
    case consts.DISPLAY_PARTIAL:
      return 'warning';
    case consts.DISPLAY_NONE:
      return 'info';
    default:
      return 'info';
  }
}

function isDisplayEnabled(display) {
  var value = Number(display);
  return value === consts.DISPLAY_ALL || value === consts.DISPLAY_PARTIAL;
}

function isDisplayPartial(display) {
  return Number(display) === consts.DISPLAY_PARTIAL;
}

/***/ }),

/***/ 2933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ProjectTaskPackageFlagDialog_vue__ = __webpack_require__(5242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__ = __webpack_require__(1821);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ProjectTaskPackageFlagDialog: __WEBPACK_IMPORTED_MODULE_1__components_ProjectTaskPackageFlagDialog_vue__["a" /* default */] },
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["a" /* consts */],
      opts: __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["g" /* opts */],
      isDisplayPartial: __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["f" /* isDisplayPartial */],
      formExpanded: true,
      loading: false,
      saving: false,
      flagDialogVisible: false,
      project: {
        id: null,
        name: '',
        number: ''
      },
      form: {
        app_task_package_display: __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["a" /* consts */].DISPLAY_NONE,
        app_task_package_title: '',
        app_task_package_whitelist_tags: [],
        system_group1_id: null,
        system_group2_id: null,
        system_group3_id: null,
        custom_flag_ids: []
      },
      systemFlags: [],
      customFlags: [],
      systemGroups: {
        group1: ['明访', '暗访'],
        group2: ['极速审核'],
        group3: ['简单', '适中', '挑战']
      },
      maxSelected: 5,
      formRules: {
        app_task_package_title: [{ validator: this.titleValidator, trigger: 'blur' }],
        app_task_package_whitelist_tags: [{ validator: this.whitelistValidator, trigger: 'change' }]
      }
    };
  },

  computed: {
    showPackageConfig: function showPackageConfig() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["e" /* isDisplayEnabled */])(this.form.app_task_package_display);
    },
    showTitle: function showTitle() {
      return this.showPackageConfig;
    },
    systemFlagsByGroup: function systemFlagsByGroup() {
      var byName = {};
      var systemFlags = this.systemFlags || [];
      systemFlags.forEach(function (f) {
        byName[f.name] = f;
      });
      var pick = function pick(names) {
        return (names || []).map(function (name) {
          return byName[name];
        }).filter(Boolean);
      };
      return {
        group1: pick(this.systemGroups.group1),
        group2: pick(this.systemGroups.group2),
        group3: pick(this.systemGroups.group3)
      };
    },
    selectedFlagCount: function selectedFlagCount() {
      return this.buildSelectedFlagIds().length;
    }
  },
  watch: {
    'form.app_task_package_display': function formApp_task_package_display(val) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["f" /* isDisplayPartial */])(val)) {
        this.form.app_task_package_whitelist_tags = [];
      }
    }
  },
  created: function created() {
    this.loadConfig();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getUserTagTable', 'getUserTagDetail']), {
    loadConfig: function loadConfig() {
      var _this = this;

      this.loading = true;
      var projectId = this.$route.params.projectId;
      return request.common('getProjectTaskPackageConfig', { projectId: projectId }).then(function (_ref) {
        var data = _ref.data;

        _this.project = {
          id: data.id,
          name: data.name,
          number: data.number
        };
        var options = data.flag_options || {};
        _this.systemFlags = options.system || [];
        _this.customFlags = options.custom || [];
        _this.systemGroups = options.system_groups || _this.systemGroups;
        _this.maxSelected = options.max_selected || 5;

        _this.form.app_task_package_display = parseInt(data.app_task_package_display || __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["a" /* consts */].DISPLAY_NONE, 10);
        _this.form.app_task_package_title = data.app_task_package_title || '';
        _this.form.app_task_package_whitelist_tags = Array.isArray(data.app_task_package_whitelist_tags)
        // remote-select / query_tag 的 id 为字符串，需与 option value 类型一致才能显示 label
        ? data.app_task_package_whitelist_tags.map(function (id) {
          return String(id);
        }) : [];

        var selected = Array.isArray(data.app_task_package_flags) ? data.app_task_package_flags.map(function (id) {
          return id * 1;
        }) : [];
        _this.applySelectedFlags(selected);
      }).finally(function () {
        _this.loading = false;
      });
    },
    applySelectedFlags: function applySelectedFlags(selectedIds) {
      var _this2 = this;

      var idSet = {};
      var selected = selectedIds || [];
      selected.forEach(function (id) {
        idSet[Number(id)] = true;
      });

      var pickGroupId = function pickGroupId(flags) {
        for (var i = 0; i < (flags || []).length; i++) {
          var id = Number(flags[i].id);
          if (idSet[id]) {
            return id;
          }
        }
        return null;
      };

      this.form.system_group1_id = pickGroupId(this.systemFlagsByGroup.group1);
      this.form.system_group2_id = pickGroupId(this.systemFlagsByGroup.group2);
      this.form.system_group3_id = pickGroupId(this.systemFlagsByGroup.group3);

      var systemIds = {};
      var groupKeys = ['group1', 'group2', 'group3'];
      groupKeys.forEach(function (key) {
        var flags = _this2.systemFlagsByGroup[key] || [];
        flags.forEach(function (f) {
          systemIds[Number(f.id)] = true;
        });
      });
      this.form.custom_flag_ids = selected.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !systemIds[id];
      });
    },
    buildSelectedFlagIds: function buildSelectedFlagIds() {
      var ids = [];
      var systemSelected = [this.form.system_group1_id, this.form.system_group2_id, this.form.system_group3_id];
      systemSelected.forEach(function (id) {
        if (id) {
          ids.push(Number(id));
        }
      });
      var customIds = this.form.custom_flag_ids || [];
      customIds.forEach(function (id) {
        var num = Number(id);
        if (ids.indexOf(num) === -1) {
          ids.push(num);
        }
      });
      return ids;
    },
    titleValidator: function titleValidator(rule, value, callback) {
      if (this.showTitle && !(value || '').trim()) {
        callback(new Error('首页任务包名称不能为空'));
      } else {
        callback();
      }
    },
    whitelistValidator: function whitelistValidator(rule, value, callback) {
      if (Object(__WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["f" /* isDisplayPartial */])(this.form.app_task_package_display) && (!value || !value.length)) {
        callback(new Error('请选择白名单标签'));
      } else {
        callback();
      }
    },
    onFlagsChanged: function onFlagsChanged() {
      var _this3 = this;

      request.common('queryProjectTaskPackageFlag', {}).then(function (_ref2) {
        var data = _ref2.data;

        var payload = data && data.data ? data.data : data;
        _this3.systemFlags = payload && payload.system || [];
        _this3.customFlags = payload && payload.custom || [];
      });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      var display = Number(this.form.app_task_package_display);
      var flagIds = this.buildSelectedFlagIds();
      if (display !== __WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["a" /* consts */].DISPLAY_NONE && flagIds.length > this.maxSelected) {
        this.$message.error('\u7CFB\u7EDF\u6807\u7B7E\u4E0E\u81EA\u5B9A\u4E49\u6807\u7B7E\u5408\u8BA1\u6700\u591A\u9009\u62E9' + this.maxSelected + '\u4E2A');
        return;
      }
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return;
        }
        _this4.saving = true;
        var payload = {
          projectId: _this4.project.id,
          app_task_package_display: _this4.form.app_task_package_display,
          app_task_package_title: _this4.form.app_task_package_title,
          app_task_package_whitelist_tags: Object(__WEBPACK_IMPORTED_MODULE_2__project_task_package_constants__["f" /* isDisplayPartial */])(display) ? _this4.form.app_task_package_whitelist_tags : [],
          app_task_package_flags: flagIds
        };
        request.common('saveProjectTaskPackageConfig', payload).then(function () {
          _this4.$message.success('保存成功');
          _this4.$router.push({ name: '任务包及培训配置' });
        }).finally(function () {
          _this4.saving = false;
        });
      });
    }
  })
});

/***/ }),

/***/ 2934:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProjectTaskPackageFlagDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tags: [],
      newTagName: '',
      loading: false,
      creating: false,
      deletingId: null,
      maxCount: 20
    };
  },

  computed: {
    tagNameLength: function tagNameLength() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(String(this.newTagName || '').trim()).length;
    },
    tipText: function tipText() {
      if (this.tags.length >= this.maxCount) {
        return '最多可创建20个自定义标签';
      }
      if (this.tagNameLength > 5) {
        return '标签名称最多支持5个字符';
      }
      return '按回车键可快速添加';
    },
    canSubmit: function canSubmit() {
      var name = String(this.newTagName || '').trim();
      if (!name || this.creating || this.tags.length >= this.maxCount) {
        return false;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(name).length > 5) {
        return false;
      }
      return !this.tags.some(function (t) {
        return t.name === name;
      });
    }
  },
  methods: {
    onOpen: function onOpen() {
      this.loadTags();
    },
    onClose: function onClose() {
      this.newTagName = '';
      this.$emit('update:visible', false);
      this.$emit('changed');
    },
    loadTags: function loadTags() {
      var _this = this;

      this.loading = true;
      return request.alert('queryProjectTaskPackageFlag', {}).then(function (_ref) {
        var data = _ref.data;

        var payload = data && data.data ? data.data : data;
        _this.tags = payload && payload.custom || [];
        if (payload && payload.max_custom) {
          _this.maxCount = payload.max_custom;
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    onCreateTag: function onCreateTag() {
      var _this2 = this;

      if (!this.canSubmit) {
        return;
      }
      this.creating = true;
      return request.alert('createProjectTaskPackageFlag', { name: this.newTagName.trim() }).then(function () {
        _this2.$message.success('添加成功');
        _this2.newTagName = '';
        _this2.$emit('changed');
        return _this2.loadTags();
      }).finally(function () {
        _this2.creating = false;
      });
    },
    onDeleteTag: function onDeleteTag(tag) {
      var _this3 = this;

      if (this.deletingId) {
        return;
      }
      this.$confirm('\u5220\u9664\u6807\u7B7E\u201C' + tag.name + '\u201D\u540E\uFF0C\u5DF2\u7ED1\u5B9A\u8BE5\u6807\u7B7E\u7684\u4EFB\u52A1\u5305\u5C06\u81EA\u52A8\u89E3\u7ED1\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.deletingId = tag.id;
        return request.alert('deleteProjectTaskPackageFlag', { id: tag.id }).then(function () {
          _this3.$message.success('删除成功');
          _this3.$emit('changed');
          return _this3.loadTags();
        }).finally(function () {
          _this3.deletingId = null;
        });
      });
    }
  }
});

/***/ }),

/***/ 5240:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5241);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5f062210", content, true, {});

/***/ }),

/***/ 5241:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".project-task-package-config__card[data-v-02629a1f]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.project-task-package-config__card-header[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.project-task-package-config__card-header i[data-v-02629a1f]{color:#909399}.project-task-package-config__body[data-v-02629a1f]{padding:20px 24px 0}.project-task-package-config__section+.project-task-package-config__section[data-v-02629a1f]{margin-top:24px}.project-task-package-config__section-title[data-v-02629a1f]{margin:0 0 16px;padding-bottom:8px;border-bottom:1px solid #ebeef5;color:#303133;font-size:16px;font-weight:600;line-height:1.5}.project-task-package-config__section-title--inline[data-v-02629a1f]{margin-bottom:4px;padding-bottom:0;border-bottom:none}.project-task-package-config__section-head[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #ebeef5}.project-task-package-config__section-actions[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-ms-flex-negative:0;flex-shrink:0}.project-task-package-config__section-desc[data-v-02629a1f]{margin:0;color:#909399;font-size:12px;line-height:1.5;font-weight:400}.project-task-package-config__row[data-v-02629a1f]{display:grid;grid-template-columns:minmax(160px,18%) minmax(0,1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:16px}.project-task-package-config__label[data-v-02629a1f]{padding-top:8px;color:#606266;font-size:14px;line-height:1.5}.project-task-package-config__label.is-required[data-v-02629a1f]:before{content:\"*\";color:#f56c6c;margin-right:4px}.project-task-package-config__field[data-v-02629a1f]{min-width:0}.project-task-package-config__form-item[data-v-02629a1f]{margin-bottom:0}.project-task-package-config__title-input[data-v-02629a1f]{max-width:480px}.project-task-package-config__project-meta[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;gap:8px 12px;padding-top:8px}.project-task-package-config__project-name[data-v-02629a1f]{color:#303133;font-size:14px;font-weight:500}.project-task-package-config__project-extra[data-v-02629a1f]{color:#909399;font-size:13px}.project-task-package-config__flag-check[data-v-02629a1f]{margin-right:16px}.project-task-package-config__empty-hint[data-v-02629a1f]{color:#909399;font-size:13px;padding:8px 0 0}.project-task-package-config__footer[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;margin:8px -24px 0;padding:12px 24px;background:#f5f7fa;border-top:1px solid #ebeef5;border-radius:0 0 8px 8px}.project-task-package-config__footer-tip[data-v-02629a1f]{color:#909399;font-size:12px}.project-task-package-config__footer-actions[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-ms-flex-negative:0;flex-shrink:0}@media (max-width:768px){.project-task-package-config__row[data-v-02629a1f]{grid-template-columns:1fr;gap:8px}.project-task-package-config__label[data-v-02629a1f]{padding-top:0}.project-task-package-config__section-head[data-v-02629a1f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.project-task-package-config__section-actions[data-v-02629a1f]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.project-task-package-config__footer[data-v-02629a1f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}}", "", {"version":3,"sources":["/workspace/src/views/project-task-package/pages/ProjectTaskPackageConfig.vue"],"names":[],"mappings":"AACA,oDAAoD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CACxL,AACD,2DAA2D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CAChc,AACD,6DAA6D,aAAa,CACzE,AACD,oDAAoD,mBAAmB,CACtE,AACD,6FAA6F,eAAe,CAC3G,AACD,6DAA6D,gBAAgB,mBAAmB,gCAAgC,cAAc,eAAe,gBAAgB,eAAe,CAC3L,AACD,qEAAqE,kBAAkB,iBAAiB,kBAAkB,CACzH,AACD,4DAA4D,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,yBAAyB,sBAAsB,8BAA8B,SAAS,mBAAmB,mBAAmB,+BAA+B,CAC/U,AACD,+DAA+D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,mBAAmB,eAAe,QAAQ,oBAAoB,aAAa,CAChQ,AACD,4DAA4D,SAAS,cAAc,eAAe,gBAAgB,eAAkB,CACnI,AACD,mDAAmD,aAAa,sDAAwD,SAAS,wBAAwB,qBAAqB,kBAAkB,kBAAkB,CACjN,AACD,qDAAqD,gBAAgB,cAAc,eAAe,eAAe,CAChH,AACD,wEAAyE,YAAY,cAAc,gBAAgB,CAClH,AACD,qDAAqD,WAAW,CAC/D,AACD,yDAAyD,eAAe,CACvE,AACD,2DAA2D,eAAe,CACzE,AACD,4DAA4D,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,2BAA2B,wBAAwB,qBAAqB,aAAa,eAAe,CACtP,AACD,4DAA4D,cAAc,eAAe,eAAe,CACvG,AACD,6DAA6D,cAAc,cAAc,CACxF,AACD,0DAA0D,iBAAiB,CAC1E,AACD,0DAA0D,cAAc,eAAe,eAAe,CACrG,AACD,sDAAsD,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,SAAS,mBAAmB,kBAAkB,mBAAmB,6BAA6B,yBAAyB,CAChX,AACD,0DAA0D,cAAc,cAAc,CACrF,AACD,8DAA8D,oBAAoB,oBAAoB,aAAa,QAAQ,oBAAoB,aAAa,CAC3J,AACD,yBACA,mDAAmD,0BAA0B,OAAO,CACnF,AACD,qDAAqD,aAAa,CACjE,AACD,4DAA4D,4BAA4B,6BAA6B,0BAA0B,sBAAsB,0BAA0B,uBAAuB,mBAAmB,CACxO,AACD,+DAA+D,uBAAuB,oBAAoB,0BAA0B,CACnI,AACD,sDAAsD,4BAA4B,6BAA6B,0BAA0B,sBAAsB,0BAA0B,uBAAuB,mBAAmB,CAClO,CACA","file":"ProjectTaskPackageConfig.vue","sourcesContent":["\n.project-task-package-config__card[data-v-02629a1f]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.project-task-package-config__card-header[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.project-task-package-config__card-header i[data-v-02629a1f]{color:#909399\n}\n.project-task-package-config__body[data-v-02629a1f]{padding:20px 24px 0\n}\n.project-task-package-config__section+.project-task-package-config__section[data-v-02629a1f]{margin-top:24px\n}\n.project-task-package-config__section-title[data-v-02629a1f]{margin:0 0 16px;padding-bottom:8px;border-bottom:1px solid #ebeef5;color:#303133;font-size:16px;font-weight:600;line-height:1.5\n}\n.project-task-package-config__section-title--inline[data-v-02629a1f]{margin-bottom:4px;padding-bottom:0;border-bottom:none\n}\n.project-task-package-config__section-head[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:16px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #ebeef5\n}\n.project-task-package-config__section-actions[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-ms-flex-negative:0;flex-shrink:0\n}\n.project-task-package-config__section-desc[data-v-02629a1f]{margin:0;color:#909399;font-size:12px;line-height:1.5;font-weight:normal\n}\n.project-task-package-config__row[data-v-02629a1f]{display:grid;grid-template-columns:minmax(160px, 18%) minmax(0, 1fr);gap:16px;-webkit-box-align:start;-ms-flex-align:start;align-items:start;margin-bottom:16px\n}\n.project-task-package-config__label[data-v-02629a1f]{padding-top:8px;color:#606266;font-size:14px;line-height:1.5\n}\n.project-task-package-config__label.is-required[data-v-02629a1f]::before{content:'*';color:#f56c6c;margin-right:4px\n}\n.project-task-package-config__field[data-v-02629a1f]{min-width:0\n}\n.project-task-package-config__form-item[data-v-02629a1f]{margin-bottom:0\n}\n.project-task-package-config__title-input[data-v-02629a1f]{max-width:480px\n}\n.project-task-package-config__project-meta[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;gap:8px 12px;padding-top:8px\n}\n.project-task-package-config__project-name[data-v-02629a1f]{color:#303133;font-size:14px;font-weight:500\n}\n.project-task-package-config__project-extra[data-v-02629a1f]{color:#909399;font-size:13px\n}\n.project-task-package-config__flag-check[data-v-02629a1f]{margin-right:16px\n}\n.project-task-package-config__empty-hint[data-v-02629a1f]{color:#909399;font-size:13px;padding:8px 0 0\n}\n.project-task-package-config__footer[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;margin:8px -24px 0;padding:12px 24px;background:#f5f7fa;border-top:1px solid #ebeef5;border-radius:0 0 8px 8px\n}\n.project-task-package-config__footer-tip[data-v-02629a1f]{color:#909399;font-size:12px\n}\n.project-task-package-config__footer-actions[data-v-02629a1f]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;-ms-flex-negative:0;flex-shrink:0\n}\n@media (max-width: 768px){\n.project-task-package-config__row[data-v-02629a1f]{grid-template-columns:1fr;gap:8px\n}\n.project-task-package-config__label[data-v-02629a1f]{padding-top:0\n}\n.project-task-package-config__section-head[data-v-02629a1f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch\n}\n.project-task-package-config__section-actions[data-v-02629a1f]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start\n}\n.project-task-package-config__footer[data-v-02629a1f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTaskPackageFlagDialog_vue__ = __webpack_require__(2934);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f24ebeda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTaskPackageFlagDialog_vue__ = __webpack_require__(5245);
function injectStyle (ssrContext) {
  __webpack_require__(5243)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f24ebeda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTaskPackageFlagDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f24ebeda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTaskPackageFlagDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5243:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5244);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("20e4e836", content, true, {});

/***/ }),

/***/ 5244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".flag-dialog[data-v-f24ebeda]{color:#606266}.flag-dialog__section-title[data-v-f24ebeda]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:12px;font-weight:700;color:#303133}.flag-dialog__section-title--create[data-v-f24ebeda]{margin-top:24px}.flag-dialog__count[data-v-f24ebeda],.flag-dialog__create-meta[data-v-f24ebeda],.flag-dialog__tip[data-v-f24ebeda]{font-size:12px;font-weight:400;color:#909399}.flag-dialog__tag-box[data-v-f24ebeda]{min-height:86px;padding:14px;border:1px solid #ebeef5;border-radius:4px}.flag-dialog__tag-grid[data-v-f24ebeda]{display:grid;grid-template-columns:repeat(5,1fr);grid-gap:10px}.flag-dialog__tag[data-v-f24ebeda]{width:100%;text-align:center}.flag-dialog__empty[data-v-f24ebeda]{line-height:58px;text-align:center;color:#909399}.flag-dialog__create-row[data-v-f24ebeda]{display:grid;grid-template-columns:1fr 112px;grid-gap:12px}.flag-dialog__create-meta[data-v-f24ebeda]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:20px;margin-top:8px}.flag-dialog__notice[data-v-f24ebeda]{margin-top:18px}", "", {"version":3,"sources":["/workspace/src/views/project-task-package/components/ProjectTaskPackageFlagDialog.vue"],"names":[],"mappings":"AACA,8BAA8B,aAAa,CAC1C,AACD,6CAA6C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,yBAAyB,sBAAsB,mBAAmB,mBAAmB,gBAAiB,aAAa,CACjS,AACD,qDAAqD,eAAe,CACnE,AACD,mHAAmH,eAAe,gBAAmB,aAAa,CACjK,AACD,uCAAuC,gBAAgB,aAAa,yBAAyB,iBAAiB,CAC7G,AACD,wCAAwC,aAAa,oCAAqC,aAAa,CACtG,AACD,mCAAmC,WAAW,iBAAiB,CAC9D,AACD,qCAAqC,iBAAiB,kBAAkB,aAAa,CACpF,AACD,0CAA0C,aAAa,gCAAgC,aAAa,CACnG,AACD,2CAA2C,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,gBAAgB,cAAc,CAC1M,AACD,sCAAsC,eAAe,CACpD","file":"ProjectTaskPackageFlagDialog.vue","sourcesContent":["\n.flag-dialog[data-v-f24ebeda]{color:#606266\n}\n.flag-dialog__section-title[data-v-f24ebeda]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:12px;font-weight:bold;color:#303133\n}\n.flag-dialog__section-title--create[data-v-f24ebeda]{margin-top:24px\n}\n.flag-dialog__count[data-v-f24ebeda],.flag-dialog__tip[data-v-f24ebeda],.flag-dialog__create-meta[data-v-f24ebeda]{font-size:12px;font-weight:normal;color:#909399\n}\n.flag-dialog__tag-box[data-v-f24ebeda]{min-height:86px;padding:14px;border:1px solid #ebeef5;border-radius:4px\n}\n.flag-dialog__tag-grid[data-v-f24ebeda]{display:grid;grid-template-columns:repeat(5, 1fr);grid-gap:10px\n}\n.flag-dialog__tag[data-v-f24ebeda]{width:100%;text-align:center\n}\n.flag-dialog__empty[data-v-f24ebeda]{line-height:58px;text-align:center;color:#909399\n}\n.flag-dialog__create-row[data-v-f24ebeda]{display:grid;grid-template-columns:1fr 112px;grid-gap:12px\n}\n.flag-dialog__create-meta[data-v-f24ebeda]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:20px;margin-top:8px\n}\n.flag-dialog__notice[data-v-f24ebeda]{margin-top:18px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"自定义任务包标签管理","visible":_vm.visible,"width":"680px","append-to-body":"","close-on-click-modal":false},on:{"open":_vm.onOpen,"close":_vm.onClose}},[_c('div',{staticClass:"flag-dialog"},[_c('div',{staticClass:"flag-dialog__section-title"},[_c('span',[_vm._v("已有自定义标签")]),_vm._v(" "),_c('span',{staticClass:"flag-dialog__count"},[_vm._v("共 "+_vm._s(_vm.tags.length)+" 个标签")])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"flag-dialog__tag-box"},[(_vm.tags.length)?_c('div',{staticClass:"flag-dialog__tag-grid"},_vm._l((_vm.tags),function(tag){return _c('el-tag',{key:tag.id,staticClass:"flag-dialog__tag",attrs:{"closable":"","disable-transitions":true},on:{"close":function($event){return _vm.onDeleteTag(tag)}}},[_vm._v("\n          "+_vm._s(tag.name)+"\n        ")])}),1):_c('div',{staticClass:"flag-dialog__empty"},[_vm._v("暂无自定义标签")])]),_vm._v(" "),_c('div',{staticClass:"flag-dialog__section-title flag-dialog__section-title--create"},[_c('span',[_vm._v("新增标签")]),_vm._v(" "),_c('span',{staticClass:"flag-dialog__tip"},[_vm._v("标签名称最多支持5个字符")])]),_vm._v(" "),_c('div',{staticClass:"flag-dialog__create-row"},[_c('el-input',{attrs:{"maxlength":"5","placeholder":"新标签名","disabled":_vm.creating || _vm.tags.length >= _vm.maxCount},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onCreateTag($event)}},model:{value:(_vm.newTagName),callback:function ($$v) {_vm.newTagName=$$v},expression:"newTagName"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus","loading":_vm.creating,"disabled":!_vm.canSubmit},on:{"click":_vm.onCreateTag}},[_vm._v("添加\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"flag-dialog__create-meta"},[_c('span',[_vm._v(_vm._s(_vm.tipText))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tagNameLength)+"/5")])]),_vm._v(" "),_c('el-alert',{staticClass:"flag-dialog__notice",attrs:{"title":"注意事项","type":"warning","closable":false,"description":"删除标签后，已绑定该标签的任务包会自动解除关联。标签名称不可重复，最多可创建20个自定义标签。"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"project-task-package-config"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/project-task-package/table' }}},[_vm._v("任务包及培训配置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__card"},[_c('div',{staticClass:"project-task-package-config__card-header",on:{"click":function($event){_vm.formExpanded = !_vm.formExpanded}}},[_c('span',[_vm._v("表单")]),_vm._v(" "),_c('i',{class:_vm.formExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.formExpanded),expression:"formExpanded"},{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",staticClass:"project-task-package-config__body",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"0"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('section',{staticClass:"project-task-package-config__section"},[_c('h3',{staticClass:"project-task-package-config__section-title"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label"},[_vm._v("项目")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},[_c('div',{staticClass:"project-task-package-config__project-meta"},[_c('span',{staticClass:"project-task-package-config__project-name"},[_vm._v(_vm._s(_vm.project.name || '-'))]),_vm._v(" "),_c('span',{staticClass:"project-task-package-config__project-extra"},[_vm._v("\n                "+_vm._s(_vm.project.number || '-')+" · ID "+_vm._s(_vm.project.id || '-')+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label is-required"},[_vm._v("APP首页是否展示任务包")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},[_c('el-form-item',{staticClass:"project-task-package-config__form-item",attrs:{"prop":"app_task_package_display"}},[_c('el-radio-group',{model:{value:(_vm.form.app_task_package_display),callback:function ($$v) {_vm.$set(_vm.form, "app_task_package_display", $$v)},expression:"form.app_task_package_display"}},_vm._l((_vm.opts.displayFormMaps),function(item){return _c('el-radio',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)],1)],1)]),_vm._v(" "),(_vm.showPackageConfig)?[_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label is-required"},[_vm._v("首页任务包名称")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},[_c('el-form-item',{staticClass:"project-task-package-config__form-item",attrs:{"prop":"app_task_package_title"}},[_c('el-input',{staticClass:"project-task-package-config__title-input",attrs:{"maxlength":"255","show-word-limit":"","clearable":"","placeholder":"请输入首页任务包名称"},model:{value:(_vm.form.app_task_package_title),callback:function ($$v) {_vm.$set(_vm.form, "app_task_package_title", $$v)},expression:"form.app_task_package_title"}})],1)],1)]),_vm._v(" "),(_vm.isDisplayPartial(_vm.form.app_task_package_display))?_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label is-required"},[_vm._v("白名单标签/标签组")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},[_c('el-form-item',{staticClass:"project-task-package-config__form-item",attrs:{"prop":"app_task_package_whitelist_tags"}},[_c('remote-select',{staticClass:"width-max project-task-package-config__title-input",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"tagname","value-key":"id","placeholder":"请输入标签或标签组关键字","query-request":_vm.getUserTagTable,"find-request":_vm.getUserTagDetail},model:{value:(_vm.form.app_task_package_whitelist_tags),callback:function ($$v) {_vm.$set(_vm.form, "app_task_package_whitelist_tags", $$v)},expression:"form.app_task_package_whitelist_tags"}})],1)],1)]):_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.showPackageConfig)?_c('section',{staticClass:"project-task-package-config__section"},[_c('div',{staticClass:"project-task-package-config__section-head"},[_c('div',[_c('h3',{staticClass:"project-task-package-config__section-title project-task-package-config__section-title--inline"},[_vm._v("标签配置")]),_vm._v(" "),_c('p',{staticClass:"project-task-package-config__section-desc"},[_vm._v("\n              同类别系统标签只能选一个，可取消勾选；系统标签与自定义标签合计最多选择 "+_vm._s(_vm.maxSelected)+" 个（当前已选 "+_vm._s(_vm.selectedFlagCount)+"）\n            ")])]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__section-actions"},[_c('el-button',{attrs:{"type":"primary","plain":"","size":"small","icon":"el-icon-setting"},on:{"click":function($event){_vm.flagDialogVisible = true}}},[_vm._v("维护自定义标签")])],1)]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label"},[_vm._v("系统标签1")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},_vm._l((_vm.systemFlagsByGroup.group1),function(flag){return _c('el-checkbox',{key:'g1-' + flag.id,staticClass:"project-task-package-config__flag-check",attrs:{"true-label":flag.id,"false-label":null},model:{value:(_vm.form.system_group1_id),callback:function ($$v) {_vm.$set(_vm.form, "system_group1_id", $$v)},expression:"form.system_group1_id"}},[_vm._v(_vm._s(flag.name))])}),1)]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label"},[_vm._v("系统标签2")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},_vm._l((_vm.systemFlagsByGroup.group2),function(flag){return _c('el-checkbox',{key:'g2-' + flag.id,staticClass:"project-task-package-config__flag-check",attrs:{"true-label":flag.id,"false-label":null},model:{value:(_vm.form.system_group2_id),callback:function ($$v) {_vm.$set(_vm.form, "system_group2_id", $$v)},expression:"form.system_group2_id"}},[_vm._v(_vm._s(flag.name))])}),1)]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label"},[_vm._v("系统标签3")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},_vm._l((_vm.systemFlagsByGroup.group3),function(flag){return _c('el-checkbox',{key:'g3-' + flag.id,staticClass:"project-task-package-config__flag-check",attrs:{"true-label":flag.id,"false-label":null},model:{value:(_vm.form.system_group3_id),callback:function ($$v) {_vm.$set(_vm.form, "system_group3_id", $$v)},expression:"form.system_group3_id"}},[_vm._v(_vm._s(flag.name))])}),1)]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__row"},[_c('label',{staticClass:"project-task-package-config__label"},[_vm._v("自定义标签")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__field"},[_c('el-checkbox-group',{attrs:{"max":5},model:{value:(_vm.form.custom_flag_ids),callback:function ($$v) {_vm.$set(_vm.form, "custom_flag_ids", $$v)},expression:"form.custom_flag_ids"}},_vm._l((_vm.customFlags),function(tag){return _c('el-checkbox',{key:tag.id,attrs:{"label":tag.id}},[_vm._v(_vm._s(tag.name))])}),1),_vm._v(" "),(!_vm.customFlags.length)?_c('div',{staticClass:"project-task-package-config__empty-hint"},[_vm._v("\n              暂无自定义标签，请点击「维护自定义标签」添加\n            ")]):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__footer"},[_c('span',{staticClass:"project-task-package-config__footer-tip"},[_vm._v("\n          保存后立即对 APP 首页任务包展示生效\n        ")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-config__footer-actions"},[_c('el-button',{on:{"click":function($event){return _vm.$router.push({name: '任务包及培训配置'})}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","native-type":"submit","loading":_vm.saving}},[_vm._v("保存")])],1)])])],1),_vm._v(" "),_c('project-task-package-flag-dialog',{attrs:{"visible":_vm.flagDialogVisible},on:{"update:visible":function($event){_vm.flagDialogVisible=$event},"changed":_vm.onFlagsChanged}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/ProjectTaskPackageConfig.187cd193d1e2aa58ff68.js